import React, { Component } from "react";
import { Colors } from "../../constants/colors";
import {
  Container,
  Row,
  Col,
  Text,
  TextRight,
  Error,
  ProcessBar,
  Bar,
} from "./styles";
import Moment from "react-moment";

const AxlMiniJobBox = ({
  job,
  onSelectJob,
  displayProgressBar,
  percent,
  containerStyle,
}) => {
  const boxColor = {
    borderColor:
      !!job.error_count && job.error_count > 0
        ? Colors.dustyRed
        : Colors.veryLightPink,
  };
  const selectJob = (e) => {
    onSelectJob && onSelectJob(job);
  };

  return (
    <Container onClick={selectJob} style={{ ...containerStyle, ...boxColor }}>
      <Row>
        <Col>
          <div>
            <Text>{`${job.shipment_count} Shipments`}</Text>
          </div>
          <div>
            {!!job.error_count && job.error_count > 0 && (
              <Error>{` ${job.error_count} ERRORS `}</Error>
            )}
            <strong>{job.name}</strong>
          </div>
        </Col>
        <Col>
          <div>
            <TextRight style={{minWidth: 150}}>
              <Moment interval={0} format={"MM/DD/YYYY @ HH:mm:ss"}>
                {job.dropoff_earliest_ts}
              </Moment>
            </TextRight>
          </div>
          <div>
            <TextRight>{` ${job.status} `}</TextRight>
          </div>
        </Col>
      </Row>
      <Row>
        {displayProgressBar && (
          <ProcessBar>
            <Bar style={{ width: `${percent ? percent : "10"}%` }} />
          </ProcessBar>
        )}
      </Row>
    </Container>
  );
};

export default AxlMiniJobBox;
